import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey, State } from './quote.reducer';

export const selectProjectState = createFeatureSelector<State>(featureKey);

export const getQuote = createSelector(selectProjectState, (state: State) => state.quote);
